/**
 * File: profileViewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class ProfileViewController {
    // @ngInject
    constructor($state, $rootScope, $scope, $stateParams, localStorageService, authService, profileCons) {
        //CurrentPage.setTitle("Profile Settings")
        let selectedUserId = $stateParams.person_id

        let profileViewCtrls = this
        profileViewCtrls.modeStatus = true;
        profileViewCtrls.editBtn = true;
        profileViewCtrls.profileData = true;
        profileViewCtrls.profileDataEdit = false;
        profileViewCtrls.getRelationDrp = false;



        $scope.firstLoad = true //flag to check the page is loaded first or not
        if (!selectedUserId) {
            $state.go('profileSetting', {}, {
                reload: true
            });
        }

        let subsUsers = undefined

        let userDetails = () => {
            authService.callAPI(profileCons.API_USER_PERSONAL + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        profileViewCtrls.eachPerson = response.result.data.details;
                        fetchFunction()
                    } catch (ex) {
                        console.log(ex)
                    }
                } else {
                    profileViewCtrls.eachPerson = undefined
                    $scope.isLoading = false
                }
                _.defer(function() {
                    $scope.$apply()
                })
            })
        }

        let getRoles = () => {
            authService.callAPI(profileCons.API_GET_PROFILE_SETTING_ROLES + localStorageService.get('school_id'), "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.rolesList = response.result.data.details;
                        userDetails()
                    } catch (ex) {
                        console.log(ex)
                    }
                } else {
                    $scope.rolesList = []
                    $scope.isLoading = false
                }
                _.defer(function() {
                    $scope.$apply()
                })
            })
        }

        let getUserModules = () => {

            authService.callAPI(profileCons.API_USER_MODULES_FEATURE + localStorageService.get('school_id') + "/" + "roleSetting", "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        let moduleDetails = response.result.data.details
                            //console.log(result)
                        if (moduleDetails && moduleDetails.feature_role) {
                            for (var i = moduleDetails.feature_role.length - 1; i >= 0; i--) {
                                let findRole = _.find(profileViewCtrls.eachPerson.role_ids, function(role) {
                                        return role == moduleDetails.feature_role[i].role_id
                                    })
                                    //console.log(findRole)
                                if (findRole != undefined) {
                                    if (moduleDetails.feature_role[i].f_id == "hodComponent") {
                                        $scope.roleHOD = true
                                    } else if (moduleDetails.feature_role[i].f_id == "hosComponent") {
                                        $scope.roleHOS = true
                                    } else if (moduleDetails.feature_role[i].f_id == "parentComponent") {
                                        $scope.rolePARENT = true
                                    } else if (moduleDetails.feature_role[i].f_id == "teacherComponent") {
                                        $scope.roleTeacher = true
                                    }else if (moduleDetails.feature_role[i].f_id == "supervisorComponent") {
                                        $scope.roleSupervisor = true
                                    }
                                }
                            }
                        }
                        _.defer(function() {
                            $scope.$apply();
                        });
                    } catch (ex) {
                        console.log(ex)
                    }
                }
            })
        }

        let fetchFunction = () => {
            if (!profileViewCtrls.eachPerson) {
                $state.go('profileSetting')
            }
            let schoolDataNew = undefined
            if (localStorageService.get('school_id')) {
                schoolDataNew = localStorageService.get('school_id')
            } else {
                schoolDataNew = localStorageService.get('school_id')
            }
            if (profileViewCtrls.eachPerson || localStorageService.get('school_id')) {
                if (profileViewCtrls.eachPerson.school_id === null || profileViewCtrls.eachPerson.school_id === undefined) {
                    toastr.error("School id will not be empty.")
                }
            } else {
                toastr.error("User data not found.")
                $state.go('profileSetting')
            }

            /* profileViewCtrls.fullRoles = Settings.findOne({
                type: "role"
            }) */

            if (profileViewCtrls.eachPerson) {
                if (profileViewCtrls.eachPerson.image && profileViewCtrls.eachPerson.image.original) {
                    profileViewCtrls.tempImg = FILE_UPLOAD_URL + profileViewCtrls.eachPerson.image.original
                } else {
                    profileViewCtrls.tempImg = "../../../img/header/teacher_profile1.png"
                }

                if (profileViewCtrls.eachPerson.role_ids) {

                    if ($scope.rolesList) {
                        $scope.rolesList = $scope.rolesList
                        $scope.assignedRoleNames = ""
                        _.each($scope.rolesList, function(item) {
                            if (profileViewCtrls.eachPerson.role_ids.indexOf(item._id) !== -1) {
                                $scope.assignedRoleNames += item.name + ", "
                            }
                        })
                        $scope.assignedRoleNames = $scope.assignedRoleNames.substring(0, $scope.assignedRoleNames.length - 2)
                        $scope.rolesList = _.uniq($scope.rolesList, false, function(oneR) {
                            return oneR._id
                        })
                        _.defer(function() {
                            $scope.$apply();
                        });
                    }


                }
                //Get Modeules
                getUserModules();
            }
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: To check login status 
         **/
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Profile Settings"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }

            getRoles()
        }




        if ($scope.firstLoad) {
            if (!profileViewCtrls.childPersonArr) {
                profileViewCtrls.childPersonArr = []
            }
        }

        profileViewCtrls.getRoleDetails = (id) => {
            $scope.roleType = id;
        }


        profileViewCtrls.getRelationBox = (studIds) => {
            if (studIds.length >= 1) {
                profileViewCtrls.getRelationDrp = true;
                if ($scope.isChildExist) {
                    $scope.showParentSaveBtn = true;
                }
            }
        }

        $scope.relationType = 'none'; //to check the relation type(Father,Mother or Guardian)
        profileViewCtrls.getRelation = (rel) => {
            $scope.relationType = rel;
            $scope.showParentSaveBtn = true;
        }

        let validate = (eachPerson) => {
            /* let pageData = UserCollection.simpleSchema().clean(eachPerson);
            UserCollection.simpleSchema().namedContext("ProfileSchema").validate(eachPerson, {
                modifier: false
            });
            let context = UserCollection.simpleSchema().namedContext("ProfileSchema");
            let errorsList = context.invalidKeys();
            let ret_val = context.invalidKeys();
            ret_val = _.map(ret_val, function(res) {
                return _.extend({
                    message: context.keyErrorMessage(res.name)
                }, res);
            });
            return ret_val */
        }

        /* profileViewCtrls.updateUser = (croppedDataUrl, basciImg) => {
            $scope.errors = {}
            let errors = validate(profileViewCtrls.eachPerson)
            if (errors.length > 0) {
                showErrors(errors)
            } else {
                if (croppedDataUrl && basciImg) {
                    this.serverUrl = FILE_UPLOAD_URL + "/server-uploads"
                    this.userPath = Meteor.userId() + "/basicprofile/"
                    let fileObj = Upload.dataUrltoBlob(croppedDataUrl)
                    uploadService.uploadCheckService(fileObj, this.serverUrl, this.userPath, function(result) {
                        if (result.url) {
                            let urlRes = result.url
                            profileViewCtrls.eachPerson.url = urlRes
                            updateUserDetails(selectedUserId)
                        }
                        if (result.progress) {
                            $scope.progressRep = result.progress
                        }
                    })
                } else {
                    updateUserDetails(selectedUserId)
                }
            }
        } */

        function updateUserDetails(selectedUserId) {
            /* Meteor.call("updateCurrentUser", profileViewCtrls.eachPerson, selectedUserId, localStorageService.get('school_id'), function(error, result) {
                if (error) {
                    if (error.error) {
                        toastr.error(error.error)
                    }
                } else {
                    profileViewCtrls.close()
                    toastr.success("Updated successfully!")
                    profileViewCtrls.userMgt = '';
                    profileViewCtrls.profileData = true;
                    profileViewCtrls.profileDataEdit = false;
                    profileViewCtrls.editBtn = true;
                }
                _.defer(function() {
                    $scope.$apply();
                });
            }); */
        }

        let showErrors = (ret_val) => {
            for (let i = 0; i < ret_val.length; i++) {
                let errorMap = ret_val[i]['name'].split('.')
                    // assignErrorValue global function written in lib/app.js 
                errorValidatorUtil.assignErrorValue($scope.errors, errorMap, ret_val[i]['message']);
            }
        }

        profileViewCtrls.editUser = () => {
            profileViewCtrls.modeStatus = false;
            profileViewCtrls.editBtn = false;
            profileViewCtrls.profileData = false;
            profileViewCtrls.profileDataEdit = true;
        }

        profileViewCtrls.cancelEdit = () => {
            profileViewCtrls.modeStatus = true;
            profileViewCtrls.editBtn = true;
        }

        profileViewCtrls.close = () => {
            profileViewCtrls.profileDataEdit = false;
            profileViewCtrls.profileData = true
            profileViewCtrls.editBtn = true;
            profileViewCtrls.eachPerson = profileViewCtrls.eachPerson
        }

    }
}

export default ProfileViewController;


// WEBPACK FOOTER //
// ./src/app/profileSetting/controllers/profileViewController.js